<template>
<div class="chapter">
<div class="inner_page">
<a id="p3"></a>
<blockquote class="sink">
<p class="left "><em>I spend a lot of darkness trying not to give up on being human.</em></p>
<p class="left "><span class="smallcaps">—TIM SEIBLES</span></p>
</blockquote>
<blockquote class="sink">
<p class="left "><em>Perhaps you’ll think it strange that an invisible man should need light, desire light, love light.</em></p>
<p class="left "><span class="smallcaps">—RALPH ELLISON</span></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?0f310e00